import websiteJson from '../../config/website.json';
import urlParser from '../js/urlParser';

export const ARTICLE_NUMBER_PER_PAGE = 9;

export const apiDomain = (() => {
	/**
	 * on Server environment (DEMO / PROD)
	 */
	if (!process.env.DEV) {
		return `//${
			websiteJson.domain[
				process.env.NODE_ENV.toLowerCase()
			].main.value
		}`;
	}

	/**
	 * local webpack dev server
	 */
	if (window.location.hostname === 'localhost') {
		return `//localhost:${websiteJson.port.apiProxyServer}`;
	}

	/**
	 * user enter dev server through ngrok service
	 *
	 * replace the 'XXXXXXXX' with the hash on your terminal,
	 * but DO NOT commit this, keep `XXXXXXXX` on git
	 */
	return '//XXXXXXXX.ap.ngrok.io';
})();

export const apiUri = `${apiDomain}/api/${urlParser.branch}/${urlParser.language}`;

export const uploadUri = `${apiDomain}/upload`;

export const GOOGLE_MAP_API_KEY = process.env.NODE_ENV === 'PRODUCTION' ?
	'AIzaSyDSwnVjeZ6DJzqSt-1K8SDpJlq_0L1vYWc'
	:
	'AIzaSyB_1KxSbALBgWlGxFzSXSTelF9he9ZSO1E';

export const FACEBOOK_APP_ID = {
	DEMO: '1910529099201920',
	PRODUCTION: '1952826854953865',
}[process.env.NODE_ENV];

export const ZOPIM_SDK_ID = {
	hualien: '4bqPWVEr9NIYvxlmMGvvZIXOKZgEN9dH',
	kaohsiung: '4bqPuUff6clXs7hYYgP9RNOS2rMpMiYu',
	taoyuan: '4bqPKPIKkMCydKbwJTDF1XFZWd6BNixM',
	xinzhuang: '4bzYcGRmCCRxhpGKH0y45BQ7QXLwzZgk',
}[urlParser.branch];

export const LANG_CULTURE = {
	tw: 'zh_TW',
	en: 'es_US',
	jp: 'ja_JP',
	cn: 'zh-CN',
};

export default 'this is app config';



// WEBPACK FOOTER //
// ./src/js/appConfig.js